import React from 'react';

const Form = ({ onSubmit, children, ...props }) => {
  
  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} {...props}>
      {children}  
    </form>
  );
};

export default Form;
